import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
@Component({
  selector: 'app-guide-file-support',
  templateUrl: './guide-file-support.component.html',
  styleUrls: ['./guide-file-support.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class GuideFileSupportComponent implements OnInit {

  lbl_back:string="back_";
  lbl_name:string="name_";
  lbl_certificate:string="certificate_";
  lbl_email:string="email_";
  lbl_cell_phone:string="cell_phone_";
  lbl_digitized_document:string="digitized_document_";
  lbl_upload_file:string="upload_file_";
  lbl_photo:string="photo_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_update: string = "update_";
  lbl_confirm: string = "confirm_";

  lstRespTranslate: TranslateRelLabelVO[];

  guideId?: string;
  token: string;
  security: SecurityDocument;
  guide: GuideModel;

  fileCert: File;
  filePhoto:File;

  imageToShow: any;


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) { 
      this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.guideId = params.guideId;
          console.debug(this.guideId);
          console.debug(this.token)
          this.getSecurity();
          this.getGuide();
        });


    }

  ngOnInit(): void {
  }


  onUploadCertificate(event){
    this.confirmationService.confirm({
      message: '¿ '+ this.lbl_are_you_sure +' '+ this.lbl_update +' '+ this.lbl_certificate +' ?',
      header: this.lbl_confirm +' '+ this.lbl_certificate,
      icon: 'pi pi-file-pdf',
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      accept: () => {
        this.fileCert = event.currentFiles[0];
        this.uploadFileSupportGuide("cert");
      }
    });

  }

  onUploadPhoto(event){
    this.confirmationService.confirm({
      message: '¿ '+ this.lbl_are_you_sure +' '+ this.lbl_update +' '+ this.lbl_photo+ ' ?',
      header: this.lbl_confirm +' '+ this.lbl_photo,
      icon: 'pi pi-file-pdf',
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      accept: () => {
        this.filePhoto = event.currentFiles[0];
        this.uploadFileSupportGuide("photo");
      }
    });

  }

  uploadFileSupportGuide(typeFileSupport : String){
    let nameFile: String = "";
    let folderId: String = "";
    const reader = new FileReader();

    if(typeFileSupport == "cert"){
      if(this.fileCert){
        console.debug(this.fileCert);
        folderId = "CERTGUIDE";
        nameFile = this.guide.guideId + "." + this.fileCert.name.split('.').pop();
        this.guide.uploadCertif = true;
        reader.readAsDataURL(this.fileCert);

      }else{
        this.messageService.add({severity:'error', summary: 'Actualizar Certificado', detail: 'No se ha seleccionado archivo', life: 3000});
        return;
      }

    }else if(typeFileSupport == "photo"){
      console.debug(this.filePhoto);

      if(this.filePhoto){
        folderId = "PHOTOGUIDE";
        nameFile = this.guide.guideId + "." +this.filePhoto.name.split('.').pop();
        this.guide.uploadPhoto = true;
        reader.readAsDataURL(this.filePhoto);
      }else{
        this.messageService.add({severity:'error', summary: 'Actualizar Fotografia', detail: 'No se ha seleccionado archivo', life: 3000});
        return;
      }

    }

    reader.onload = () => {
      let array = (<string>reader.result).split(",");
      this.apiService.saveFileSantoApp({
        "nameFile": nameFile,
        "base64File":array[1],
        "folderId": folderId
      }).then(
        data => {
          this.updateGuide();
          this.messageService.add({severity:'success', summary: 'Actualizacion', detail: 'Se agreego archivo correctamente', life: 3000});
      }).catch(error => {
        console.error(error);
      });
    };
  }


  downloadCertificate(){
    this.apiService.getFileSantoApp({
        "nameFile": this.guide.guideId+".pdf",
        "folderId":"CERTGUIDE"    
    }).then(
      data => {
        const source = `data:application/octet-stream;base64,${data.base64File}`;
         const link = document.createElement("a");
         link.href = source;
         link.download = `${this.guide.guideId+".pdf"}`
         link.click();
    })
  }

  downloadPhoto(){
    this.apiService.getFileSantoApp({
        "nameFile": this.guide.guideId+".jpg",
        "folderId":"PHOTOGUIDE"    
    }).then(
      data => {
        const source = `data:image/jpg;base64,${data.base64File}`;
        this.imageToShow = source;
    })
  }

  updateGuide(){

    this.apiService.updateGuide(this.guide).then(
      data => {
        this.guide = data;
        this.downloadPhoto();
        this.messageService.add({severity:'success', summary: 'Actualizacion', detail: 'Se actualizo guía correctamente', life: 3000});
    }).catch(error => {
      console.error(error);
    });
  }


  getSecurity(){
    if(this.token){
      this.apiService.findSecurityById({"id":this.token}).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();           
      }).catch(error => {
        console.error(error);
      });
    }
    
  }

  getGuide(){
    if(this.guideId){
      this.apiService.getGuideById({"guideId":this.guideId}).then(
        data => {
          this.guide = data;
          if(this.guide.uploadPhoto){
            this.downloadPhoto();
          }      
      }).catch(error => {
        console.error(error);
      });
    }
  }
  getTranslatedLabels() {
    let map = new Map();
  
    this.apiService.listByLanguageMultFields({
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_back,
        this.lbl_name,
        this.lbl_email,
        this.lbl_certificate,
        this.lbl_cell_phone,
        this.lbl_digitized_document,
        this.lbl_upload_file,
        this.lbl_photo,
        this.lbl_are_you_sure,
        this.lbl_update,
        this.lbl_confirm
        ]
      }).then(
        trDocs => {
          this.lstRespTranslate = trDocs;
  
          trDocs.forEach((element) => {
            map.set(element.labelId, element.translation);
          });
  
          this.lbl_back = map.get(this.lbl_back);
          this.lbl_name = map.get(this.lbl_name);
          this.lbl_certificate = map.get(this.lbl_certificate);
          this.lbl_email = map.get(this.lbl_email);
          this.lbl_cell_phone = map.get(this.lbl_cell_phone);
          this.lbl_digitized_document = map.get(this.lbl_digitized_document);
          this.lbl_upload_file = map.get(this.lbl_upload_file);
          this.lbl_photo = map.get(this.lbl_photo);
          this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
          this.lbl_update = map.get(this.lbl_update);
          this.lbl_confirm = map.get(this.lbl_confirm);


        });
      }
    

  goBack(){
    window.close();
  };

}
